import { useState, useEffect } from "react";
import axios from "axios";
import { Bounce, toast } from "react-toastify";

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export default function OpeningHours() {
  const [openingHours, setOpeningHours] = useState(
    daysOfWeek.map((day) => ({
      day,
      open_time: "10:00",
      close_time: "19:00",
      is_closed: false
    }))
  );

  const optionToast = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };

  const storedUserPreferences = getDataFromlocalStorage("userData");

  useEffect(() => {
    axios
      .post(window.CARLOCA_API + "/get/opening-hours",
        { dealer_id: storedUserPreferences?.id })
      .then((res) => {
        if (res.data.length) {
          setOpeningHours(
            daysOfWeek.map((day) => {
              const found = res.data.find((d) => d.day === day);
              return found ? {
                ...found,
                is_closed: found.open_time === null || found.close_time === null
              } : {
                day,
                open_time: "09:00",
                close_time: "17:00",
                is_closed: false
              };
            })
          );
        }
      })
      .catch(console.error);
  }, []);

  const handleChange = (index, field, value) => {
    const updatedHours = [...openingHours];

    if (field === "is_closed") {
      updatedHours[index] = {
        ...updatedHours[index],
        is_closed: value,
        open_time: value ? null : "09:00",
        close_time: value ? null : "17:00"
      };
    } else {
      updatedHours[index][field] = value;
    }

    setOpeningHours(updatedHours);
  };

  const handleSubmit = () => {
    const dataToSend = openingHours.map(hour => ({
      ...hour,
      open_time: hour.is_closed ? null : hour.open_time,
      close_time: hour.is_closed ? null : hour.close_time
    }));

    axios
      .post(
        window.CARLOCA_API + "/update/opening-hours",
        {
          dealer_id: storedUserPreferences?.id,
          opening_hours: dataToSend
        }
      )
      .then(() => toast.success("Successfully updated your opening hours!", optionToast))
      .catch(error => {
        console.error(error);
        toast.error("Failed to update opening hours!", optionToast);
      });
  };

  return (
    <div className="card mt-4 border-0">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold fs-6">Opening Hours</h5>
          <div className="border rounded px-2 py-1">
            <button
              className="d-flex align-items-center justify-content-center"
              style={{
                fontSize: "12px",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
              onClick={handleSubmit}
            >
              <span className="blue">Save Change</span>
            </button>
          </div>
        </div>
        <div className="table-responsive">

          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "4rem" }}>Closed</th>
                <th>Day</th>
                <th className="text-center">Open Time</th>
                <th className="text-center">Close Time</th>
              </tr>
            </thead>
            <tbody>
              {openingHours.map((hour, index) => (
                <tr key={hour.day}>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={hour.is_closed}
                      onChange={(e) => handleChange(index, "is_closed", e.target.checked)}
                    />
                  </td>
                  <td style={{ verticalAlign: "middle" }}>{hour.day}</td>
                  <td style={{ width: "9rem" }}>
                    <input
                      style={{ width: "9rem" }}
                      type="time"
                      className="form-control"
                      value={hour.open_time || ""}
                      onChange={(e) => handleChange(index, "open_time", e.target.value)}
                      disabled={hour.is_closed}
                    />
                  </td>
                  <td style={{ width: "9rem" }}>
                    <input
                      style={{ width: "9rem" }}
                      type="time"
                      className="form-control"
                      value={hour.close_time || ""}
                      onChange={(e) => handleChange(index, "close_time", e.target.value)}
                      disabled={hour.is_closed}
                    />
                  </td>
                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}